import { render } from "./FormTrueFalse.vue?vue&type=template&id=73c9bf02"
import script from "./FormTrueFalse.vue?vue&type=script&lang=js"
export * from "./FormTrueFalse.vue?vue&type=script&lang=js"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__